/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalendarProvider } from '../models/CalendarProvider';
import type { JoinMeetingPayload } from '../models/JoinMeetingPayload';
import type { JoinMeetingResponse } from '../models/JoinMeetingResponse';
import type { PublicMeetingBranding } from '../models/PublicMeetingBranding';
import type { PublicMeetingInfo } from '../models/PublicMeetingInfo';
import type { ZoomWebhookEvent } from '../models/ZoomWebhookEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CalendarsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Add Calendar Account Callback
     * Add Calendar Account Callback
     * @param code
     * @param state
     * @param provider
     * @param error
     * @returns any
     * @throws ApiError
     */
    public addCalendarAccountCallback(
        code: string,
        state: string,
        provider?: CalendarProvider,
        error?: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/calendars/callback',
            query: {
                'code': code,
                'state': state,
                'provider': provider,
                'error': error,
            },
        });
    }
    /**
     * Add Microsoft Calendar Account Callback
     * Add Microsoft Calendar Account Callback
     * @param code
     * @param state
     * @returns any
     * @throws ApiError
     */
    public addMicrosoftCalendarAccountCallback(
        code: string,
        state: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/calendars/microsoft/callback',
            query: {
                'code': code,
                'state': state,
            },
        });
    }
    /**
     * Add Tebuto Meet Online Meeting Account Callback
     * Add Tebuto Meet Online Meeting Account Callback
     * @param state
     * @returns any
     * @throws ApiError
     */
    public addTebutoMeetOnlineMeetingAccountCallback(
        state: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/online-meetings/tebuto-meet/callback',
            query: {
                'state': state,
            },
        });
    }
    /**
     * Add Microsoft Online Meeting Account Callback
     * Add Microsoft Online Meeting Account Callback
     * @param code
     * @param state
     * @returns any
     * @throws ApiError
     */
    public addMicrosoftOnlineMeetingAccountCallback(
        code: string,
        state: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/online-meetings/microsoft/callback',
            query: {
                'code': code,
                'state': state,
            },
        });
    }
    /**
     * Add Microsoft Online Meeting Account Callback
     * Add Microsoft Online Meeting Account Callback
     * @param code
     * @param state
     * @returns any
     * @throws ApiError
     */
    public addMicrosoftOnlineMeetingAccountCallback1(
        code: string,
        state: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/online-meetings/zoom/callback',
            query: {
                'code': code,
                'state': state,
            },
        });
    }
    /**
     * @param xZmSignature
     * @param xZmRequestTimestamp
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public publicOnlineMeetingsControllerZoomWebhook(
        xZmSignature: string,
        xZmRequestTimestamp: string,
        requestBody: ZoomWebhookEvent,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/online-meetings/zoom/webhook',
            headers: {
                'x-zm-signature': xZmSignature,
                'x-zm-request-timestamp': xZmRequestTimestamp,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get public meeting branding
     * Get Tebuto Meet prejoin branding (practice logo) by meeting slug
     * @param slug
     * @returns PublicMeetingBranding
     * @throws ApiError
     */
    public getPublicMeetingBranding(
        slug: string,
    ): CancelablePromise<PublicMeetingBranding> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/online-meetings/tebuto-meet/{slug}/branding',
            path: {
                'slug': slug,
            },
        });
    }
    /**
     * Get public meeting info
     * Get public meeting info by slug (no authentication required)
     * @param slug
     * @returns PublicMeetingInfo
     * @throws ApiError
     */
    public getPublicMeetingInfo(
        slug: string,
    ): CancelablePromise<PublicMeetingInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/online-meetings/tebuto-meet/{slug}',
            path: {
                'slug': slug,
            },
        });
    }
    /**
     * Join meeting as guest
     * Join a Tebuto Meet meeting as a guest (no authentication required). Generates a fresh JWT token for the given display name.
     * @param slug
     * @param requestBody
     * @returns JoinMeetingResponse
     * @throws ApiError
     */
    public joinMeetingAsGuest(
        slug: string,
        requestBody: JoinMeetingPayload,
    ): CancelablePromise<JoinMeetingResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/online-meetings/tebuto-meet/{slug}/join',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
